import React from "react";
import Skeleton from "react-loading-skeleton";

const CartSkeleton = () => {
  return (
    <div>
      <div className="flex justify-between p-4 mt-12 lg:mt-24 cart-section flex-col lg:flex-row cart-page px-[5%] lg:px-[4%]">
        <div className="w-full lg:w-[75%] rounded-md lg:px-6 lg:pl-0">
          <div className="item-column mb-6">
            <Skeleton height={"80vh"} />
          </div>
        </div>
        <div className="w-full lg:w-[25%]" id="order-summary">
          <Skeleton height={"80vh"} />
        </div>
      </div>
    </div>
  );
};

export default CartSkeleton;
